module.exports = "/images/laptop-stand-swag.jpg";